import React, { useState } from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";

const DeleteTypeModal = ({ preview, previewHandler, selectedData, sucessHandler }) => {
  // STATES
  const [deleteLoader, setdeleteLoader] = useState(false);
  
  // CONST VALS
  const { http } = global.services;

  const deleteFileHandler = () => {
    setdeleteLoader(true);
    http
      .delete(`communication/${selectedData.id}`)
      .finally(() => setdeleteLoader(false))
      .then(() => {
        toast.success("Type deleted successfully");
        sucessHandler();
        previewHandler();
      })
      .catch((err) => {
        const message = err?.response?.data?.error || "Something went wrong";
        toast.error(message);
      });
  };

  return (
    <Modal
      visible={preview}
      centered
      className="delete-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Delete Type</h2>
      <p>
        Are you sure you want to delete <strong>{selectedData?.title}</strong>? This action cannot be undone.
      </p>
      <div className="action-box">
        <button onClick={previewHandler}>Cancel</button>
        <button className="delete" onClick={deleteFileHandler}>
          {deleteLoader ? <BeatLoader size={8} color="#fff" /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteTypeModal;
